<template>
  <div>
    <section id="course-page" class="course-page-section">
      <div class="container">
        <div class="row">
          <div class="col-md-9">
            <div class="genius-post-item">
              <div class="tab-container">
                <div id="tab1" class="pt35">
                  <div class="best-course-area best-course-v2">
                    <div class="row">
                      <div v-for="item in courses.Items" :key="item.Id" class="col-md-4" :style="item.IsOpen==1?'':'opacity: 1;'" @click="goCourseDetails(item.Id)">
                        <div class="best-course-pic-text relative-position" style="cursor: pointer;">
                          <div class="best-course-pic relative-position">
                            <img :src="item.Pic" alt="">
                            <div class="course-details-btn">
                              <a>进入报名 <i class="fas fa-arrow-right"></i></a>
                            </div>
                            <div class="blakish-overlay"></div>
                            <label v-if="item.IsHot==1" class="item-status-label shz">
                              <i class="iconfont icon-shandian-shi" style="margin-bottom: -4px;"></i>
                              <span>火热报名中</span>
                            </label>
                          </div>
                          <div class="best-course-text">
                            <div class="course-title mb20 headline relative-position">
                              <h3 style="-webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    display: block;
    display: -webkit-box;"><a>{{item.Name}}</a></h3>
                            </div>
                            <div class="course-meta" v-if="item.ManualUrl && item.IsOpen == 1">
                              <span class="course-category"><a>报名开放</a></span>
                              <span class="course-author" @click="stopPropagation($event)"><a style="color:#17d0cf !important" target="_blank" :href="item.ManualUrl">查看报名流程</a></span>
                            </div>
                            <div class="course-meta" v-else>
                              <span class="course-category"><a>{{item.JobCount}}个岗位</a></span>
                              <span class="course-author"><a>{{item.IsOpen==1?"报名开放":"暂未开放"}}</a></span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- /course -->
                    </div>
                    <el-pagination style="display: flex; justify-content: center;" layout="total, prev, pager, next" :page-size="9" :total="courses.TotalRecords" @current-change="handleCurrentChange">
                    </el-pagination>
                  </div>
                </div><!-- /tab-1 -->
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="side-bar-widget  first-widget">
              <h2 class="widget-title text-capitalize"><span>搜索 </span>Search</h2>
              <el-input class="k-input-default mb20" placeholder="课程名称" v-model.trim="queryModel.Name" clearable @keyup.enter.native="search" />

              <el-button class="k-btn-primary lg" @click="search">搜 索</el-button>
            </div>
            <component :is="newsView" ref="newsView"></component>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import { Vue, mapGetters } from '../base/base.js';

export default {
  data() {
    return {
      queryModel: {
        Page: 1,
        PageSize: 9,
        Name: ''
      }
    }
  },

  computed: {
    ...mapGetters({
      courses: 'getCourses'
    })
  },

  created() {
    this.newsView = Vue.component('newsView', function (resolve) {
      require(['./new/list'], resolve)
    });
  },

  mounted() {
    this.search();
  },

  methods: {
    search() {
      this.$store.dispatch('getCourses', this.queryModel);
    },
    goCourseDetails(id) {
      let routeUrl = this.$router.resolve({
        path: 'courseDetails',
        query: {
          Id: id
        }
      });
      window.open(routeUrl.href, '_blank');
    },
    handleCurrentChange(val) {
      this.queryModel.Page = val;
      this.$store.dispatch('getCourses', this.queryModel);
    },
    stopPropagation(e) {
      e.stopPropagation();
    }
  }
}
</script>
<style lang="scss" scoped>
a:not([href]):not([tabindex]) {
  color: #fff;
  text-decoration: none;
  cursor: pointer;
}
.course-title h3 {
  a {
    color: #333333 !important;
    text-decoration: none;
  }
}

.course-category,
.course-author {
  a {
    color: #777777 !important;
  }
}

.item-status-label {
  position: absolute;
  left: -60px;
  top: -60px;
  width: 120px;
  height: 120px;
  background-color: #ff6715;
  text-align: center;
  transform: rotate(-45deg);
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  i {
    color: #fff;
  }
  span {
    margin-top: 4px;
    margin-bottom: 8px;
    color: #fff;
    font-size: 12px;
  }
  &.tg {
    background-color: #16cfd0;
  }
  &.jj {
    background-color: #a8a8a8;
  }
  &.shz {
    background-color: #ff6715;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home/store.vue